import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { URLS } from 'config';
import { useCurrentJob, useCurrentJobLead } from 'hooks';
import { getLatestLoanPayment, getLoanProvider } from 'utils';

import Pages from './Pages';
import { FORM_STEPS, FORM_STEPS_KEYS } from './constants';
import { formatLeadToCredit } from './helpers';

export default function useContinueApplication() {
  const { job, isLoading: jobIsLoading, isSolar } = useCurrentJob();
  const { lead, isLoading: leadIsLoading } = useCurrentJobLead();
  const { push } = useHistory();

  const isLoading = jobIsLoading || leadIsLoading;

  const latestLoan = useMemo(() => {
    if (!job) return null;
    return getLatestLoanPayment(job);
  }, [job]);

  const provider = getLoanProvider(job);

  const pages = useMemo(() => {
    if (isSolar) return Pages;
    const subset = { ...Pages };
    delete subset[FORM_STEPS.DISCLAIMER];
    return subset;
  }, [isSolar]);

  const steps = useMemo(() => {
    if (isSolar) return FORM_STEPS_KEYS;
    const keys = [...FORM_STEPS_KEYS];
    keys.splice(1, 1);
    return keys;
  }, [isSolar]);

  const initialData = useMemo(() => {
    if (isLoading)
      return {
        isLoading,
      };
    return {
      job,
      lead,
      credit: formatLeadToCredit(lead),
      isLoading,
      provider,
    };
  }, [isLoading, job, lead, provider]);

  useEffect(() => {
    if (!job) return;
    if (latestLoan) return;
    const id = job?.id || '';
    push(URLS.quote.replace(':id?', id));
  }, [jobIsLoading, job, latestLoan, push]);

  return {
    pages,
    steps,
    initialData,
  };
}
